import { render, staticRenderFns } from "./MailListProvider.vue?vue&type=template&id=4164fc0a&scoped=true&"
import script from "./MailListProvider.vue?vue&type=script&lang=ts&"
export * from "./MailListProvider.vue?vue&type=script&lang=ts&"
import style0 from "./MailListProvider.vue?vue&type=style&index=0&id=4164fc0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4164fc0a",
  null
  
)

export default component.exports